export const requestFilterSectionIds = Object.freeze({
  savedFilters: 'saved-filters',
  date: 'date',
  people: 'people',
  service: 'service',
  address: 'address',
  warranty: 'warranty',
  paidOrders: 'paid-orders',
  additionalInfo: 'additional-info',
});

export const requestFilterSectionDefaults = Object.freeze({
  [requestFilterSectionIds.savedFilters]: false,
  [requestFilterSectionIds.date]: true,
  [requestFilterSectionIds.people]: true,
  [requestFilterSectionIds.service]: true,
  [requestFilterSectionIds.address]: false,
  [requestFilterSectionIds.warranty]: true,
  [requestFilterSectionIds.paidOrders]: false,
  [requestFilterSectionIds.additionalInfo]: false,
});

export const requestFilterCollapsibleSectionIds = Object.freeze(
  Object.keys(requestFilterSectionDefaults)
);

export const REQUEST_FILTER_SECTION_EXPANSION_STORAGE_KEY =
  'dspx:request-filter:section-expansion:v1';
